<svelte:options accessors/>
<script lang="ts">
    import NauiInput from "../../naui/atoms/NauiInput.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {httpRequest} from "../../utils";
    import Dialog, {Title, Content, Actions} from '@smui/dialog';

    let dialog={
        open:false,
        message:''
    }
    export let url_cambio_contrasena = ""

    let body_request = {
        contrasena_actual_or_code: "",
        metodo: "",
        nueva_contrasena: ""
    }

    let flag = true;
    let flag_end=true
    let label_general = "Para cambiar tu contraseña ingresa la contraseña actual y a continuación la nueva contraseña. Recuerda que la\n" +
        "        contraseña debe contener 8 caracteres, usar mayúscula, minúscula y números."
    let label_boton = "Enviar codigo."

    let metodo = ""
    let email = ""
    let cel = ""
    let contrasena_actual_or_code = ""
    let label_contrasena_actual_or_code = "Contraseña actual"
    let nueva_contrasena = ""
    let confir_contrasena = ""


    function changue_fields() {
        flag = false
        label_general = "Para completar el proceso por favor ingrese el codigo que recibio."
        label_boton = "Cambiar contraseña"
        label_contrasena_actual_or_code = "Codigo"
        console.log(contrasena_actual_or_code)
        contrasena_actual_or_code = ""
    }

    async function select_operation() {
        if (flag) {
            if(nueva_contrasena!==confir_contrasena || confir_contrasena!==""){
                dialog.message='Las contraseñas no coinciden';
                dialog.open=true
                return
            }
            console.log('Para enviar codigo')
            body_request.contrasena_actual_or_code = contrasena_actual_or_code
            body_request.metodo = metodo

            await httpRequest({
                method: 'post',
                data: body_request,
                url: url_cambio_contrasena
            })
                .then(res => res.json())
                .then(data => {
                    // TODO falta controlar en tiempo real que las nuevas contraseñas coincidan

                    console.log(data)
                    if (data.validacion === 'Token válido') {

                        changue_fields()
                        label_general = data.message

                    } else {
                        alert("Contraseña actual incorrecta");
                    }
                });


        } else if (!flag) {
            console.log('Para cambiar la contrasena')
            body_request.contrasena_actual_or_code = contrasena_actual_or_code
            body_request.metodo = ""
            body_request.nueva_contrasena = nueva_contrasena

            await httpRequest({
                method: 'post',
                data: body_request,
                url: url_cambio_contrasena
            })
                .then(res => res.json())
                .then(data => {
                    label_general = data.message
                    flag_end=false
                });

        }
    }


</script>
<fieldset>
    <legend>Cambiar contraseña</legend>
    <p>{label_general}</p>
    <div class="mt-2 max-w-400px sy-1">
        {#if flag_end}
        <NauiInput type="password" label="{label_contrasena_actual_or_code}" bind:value={contrasena_actual_or_code}/>
        {/if}

            {#if flag}
            <NauiInput type="password" label="Nueva contraseña" bind:value={nueva_contrasena}/>
            <NauiInput type="password" label="Confirmar nueva contraseña" bind:value={confir_contrasena}/>

            <label for="radio-email" class="box-l sx-ii pointer">
                <!--                <input id="radio-email" type="radio" name="metodo" value="email" required-->
                <!--                       on:select={()>={metodo="email", console.log(metodo)}}>-->
                <input id="radio-email" type="radio" name="metodo" value={"email"} required bind:group={metodo}
                       on:change={()=>console.log(metodo)}>
                <span>Correo</span>
            </label>
            <label for="radio-cel" class="box-l sx-ii pointer">
                <input id="radio-cel" type="radio" name="metodo" value={"celular"} required bind:group={metodo}
                       on:change={()=>console.log(metodo)}>
                <span>Celular</span>
            </label>
        {/if}

        {#if flag_end}
        <div class="max-w-300px pt-1">
            <NauiButton caption="{label_boton}" color="accent" mode="solid" on:click={select_operation}/>
        </div>
        {/if}

    </div>
</fieldset>

    <Dialog bind:open={dialog.open}>
        <Content>{ dialog.message }</Content>
        <Actions>
            <NauiButton caption="Aceptar" color="accent" mode="solid" on:click={() => {dialog.open = false;}}/>
        </Actions>
    </Dialog>